import { useConfigEditor, Section, Field, TextArea, ImageInput, SaveBar } from "../../lib/admin-shared";
import { Globe } from "lucide-react";

const PAGES = [
    { key: "home", label: "Home (/)", hint: "Landing page meta — most important for sharing." },
    { key: "about", label: "About (/about)" },
    { key: "programs", label: "Programs (/programs)" },
    { key: "news", label: "News & Stories (/news)" },
    { key: "resources", label: "Resources (/resources)" },
    { key: "gallery", label: "Gallery (/gallery)" },
    { key: "partners", label: "Partners (/partners)" },
    { key: "donate", label: "Donate (/donate)" },
    { key: "careers", label: "Careers (/careers)" },
    { key: "contact", label: "Contact (/contact)" },
];

export default function SeoPagesEditor() {
    const { cfg, set, save, saving, saved, loading } = useConfigEditor();
    if (loading || !cfg) return <div className="text-muted-foreground">Loading…</div>;

    const pages = cfg.seo_pages || {};
    const setPage = (key, field, value) => {
        const next = { ...pages, [key]: { ...(pages[key] || {}), [field]: value } };
        set("seo_pages", next);
    };

    return (
        <div className="max-w-5xl space-y-8" data-testid="seo-pages-editor">
            <div>
                <h1 className="font-display text-4xl mb-2">Per-Page SEO</h1>
                <p className="text-muted-foreground max-w-2xl">
                    Override the global SEO defaults for each public page. Leave a field blank to fall back to the global site SEO values
                    (set under <em>Site Identity</em>).
                </p>
            </div>

            <Section title="Global defaults" description="These are used when a page-specific override is blank.">
                <Field label="Site title" value={cfg.seo_title} onChange={(v) => set("seo_title", v)} testid="global-seo-title" />
                <TextArea label="Site description" value={cfg.seo_description} onChange={(v) => set("seo_description", v)} rows={3} testid="global-seo-desc" />
                <Field label="Keywords (comma-separated)" value={cfg.seo_keywords} onChange={(v) => set("seo_keywords", v)} testid="global-seo-keywords" />
            </Section>

            {PAGES.map((p) => {
                const data = pages[p.key] || {};
                return (
                    <Section key={p.key} title={p.label} description={p.hint}>
                        <Field
                            label="Page title"
                            value={data.title}
                            onChange={(v) => setPage(p.key, "title", v)}
                            testid={`seo-${p.key}-title`}
                            placeholder="Leave blank to use global"
                        />
                        <TextArea
                            label="Meta description"
                            value={data.description}
                            onChange={(v) => setPage(p.key, "description", v)}
                            rows={3}
                            testid={`seo-${p.key}-desc`}
                            placeholder="Leave blank to use global"
                        />
                        <div>
                            <span className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2 block">Social share image (og:image)</span>
                            <ImageInput
                                value={data.og_image}
                                onChange={(v) => setPage(p.key, "og_image", v)}
                                testid={`seo-${p.key}-og`}
                            />
                            <p className="text-xs text-muted-foreground mt-2">Recommended: 1200×630 px JPG/PNG.</p>
                        </div>
                    </Section>
                );
            })}

            <SaveBar onSave={save} saving={saving} saved={saved} />
        </div>
    );
}
